(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discovery-preorder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bright-discovery-preorder')) {
  customElements.define('bright-discovery-preorder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        this.setupCompactDock();
        this.setupDeliveryProgress();
        if (this.heroObserver) this.heroObserver.observe(this.querySelector('.bd-hero'));
        if (this.deliveryObserver) this.deliveryObserver.observe(this.querySelector('.bd-delivery'));
        this.update();
        return;
      }
      this.ready = true;
      const delivery = this.querySelector('.bd-delivery');
      const deliveryText = this.querySelector('.bd-delivery-text');
      const fitDelivery = () => {
        if (!delivery || !deliveryText || !this.isConnected) return;
        delivery.style.fontSize = '';
        const style = getComputedStyle(delivery);
        const available = delivery.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const width = deliveryText.getBoundingClientRect().width;
        if (available > 0 && width > available) {
          delivery.style.fontSize = Math.max(1, parseFloat(style.fontSize) * (available - 2) / width) + 'px';
        }
      };
      fitDelivery();
      if ('ResizeObserver' in window) {
        let lastWidth = -1;
        this.deliveryObserver = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width === lastWidth) return;
          lastWidth = width;
          fitDelivery();
        });
        this.deliveryObserver.observe(delivery);
      }
      if (document.fonts) document.fonts.ready.then(fitDelivery);

      this.form = this.querySelector('form');
      this.inputs = [...this.querySelectorAll('.bd-quantity')];
      this.submit = this.querySelector('.bd-submit');
      this.status = this.querySelector('.bd-status');
      this.label = this.submit.textContent;
      this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency});
      this.form.addEventListener('input', event => {
        this.update();
        this.keepControlVisible(event.target);
        if (Date.now() - (this.lastCartRefresh || 0) > 1500) this.refreshDeliveryCart();
      });
      this.form.addEventListener('focusin', event => {
        if (!event.target.matches('.bd-quantity,[data-step]')) return;
        this.keepControlVisible(event.target);
        if (Date.now() - (this.lastCartRefresh || 0) > 1500) this.refreshDeliveryCart();
      });
      this.form.addEventListener('click', event => {
        const button = event.target.closest('[data-step]');
        if (!button || this.busy) return;
        const input = button.closest('.bd-stepper').querySelector('.bd-quantity');
        input.value = Math.min(input.max === '' ? Infinity : Number(input.max), Math.max(0, (Number(input.value) || 0) + Number(button.dataset.step)));
        this.update();
        this.keepControlVisible(button);
        if (Date.now() - (this.lastCartRefresh || 0) > 1500) this.refreshDeliveryCart();
      });
      this.form.addEventListener('submit', event => this.add(event));
      this.initialRewards = this.querySelector('[data-rewards-output]').textContent;
      this.querySelectorAll('a[href^="#bd-"]').forEach(link => link.addEventListener('click', event => {
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        if (target.tagName === 'DETAILS') target.open = true;
        target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      }));
      if ('IntersectionObserver' in window) {
        this.heroObserver = new IntersectionObserver(entries => this.classList.toggle('bd-browsing', !entries[0].isIntersecting));
        this.heroObserver.observe(this.querySelector('.bd-hero'));
      } else this.classList.add('bd-browsing');
      this.setupCompactDock();
      this.setupDeliveryProgress();
      this.update();
    }
    disconnectedCallback() {
      if (this.heroObserver) this.heroObserver.disconnect();
      if (this.deliveryObserver) this.deliveryObserver.disconnect();
      if (this.dockObserver) this.dockObserver.disconnect();
      this.dockObserver = null;
      this.dockHeight = null;
      if (this.cartController) this.cartController.abort();
      this.cartController = null;
      this.cartRequest = null;
      window.removeEventListener('pageshow', this.onCartRefresh);
      window.removeEventListener('focus', this.onCartRefresh);
      document.removeEventListener('visibilitychange', this.onCartVisibility);
      document.removeEventListener('cart:updated', this.onCartRefresh);
      this.progressActive = false;
      if (this.compactMedia) this.compactMedia.removeEventListener('change', this.onCompactChange);
      if (this.offerInfo) this.offerInfo.removeEventListener('click', this.onOfferInfo);
      this.compactActive = false;
      document.documentElement.style.removeProperty('--alchemist-preorder-dock-height');
    }
    setupCompactDock() {
      if (this.compactActive) return;
      this.compactActive = true;
      this.compactCopy = JSON.parse(this.querySelector('[data-compact-copy]').textContent);
      this.compactMedia = window.matchMedia('(max-width:749px)');
      this.compactNumber = new Intl.NumberFormat(this.dataset.locale, {minimumFractionDigits:0,maximumFractionDigits:2});
      this.offerInfo = this.querySelector('[data-offer-info]');
      this.offerDetails = this.querySelector('[data-offer-details]');
      this.onOfferInfo = () => {
        const expanded = this.offerInfo.getAttribute('aria-expanded') !== 'true';
        this.offerInfo.setAttribute('aria-expanded', String(expanded));
        this.offerDetails.hidden = !expanded;
      };
      this.onCompactChange = () => {
        if (!this.compactMedia.matches && this.offerInfo) {
          this.offerInfo.setAttribute('aria-expanded', 'false');
          this.offerDetails.hidden = true;
        }
        this.update();
      };
      if (this.offerInfo) this.offerInfo.addEventListener('click', this.onOfferInfo);
      this.compactMedia.addEventListener('change', this.onCompactChange);
    }
    updateCompactDock(count, valid) {
      const copy = (key, quantity) => this.compactCopy[key].replaceAll('__COUNT__', String(quantity));
      this.querySelector('[data-compact-count]').textContent = count === 1 ? copy('count_one') : copy('count', count);
      this.querySelector('[data-compact-rewards]').textContent = count === 0 ? copy('rewards_empty') : count === 1 ? copy('rewards_one') : copy('rewards', count);
      if (!this.busy) this.submit.textContent = this.compactMedia.matches && count === 0 && valid ? this.compactCopy.empty_button : this.label;
      this.classList.toggle('bd-selection-invalid', !valid);
      this.classList.remove('bd-submit-error');
    }
    setupDeliveryProgress() {
      this.dock = this.querySelector('.bd-dock');
      this.shippingProgress = this.querySelector('[data-delivery-progress]');
      if (this.dock && 'ResizeObserver' in window && !this.dockObserver) {
        this.dockObserver = new ResizeObserver(() => this.measureDock());
        this.dockObserver.observe(this.dock);
      }
      this.measureDock();
      if (!this.shippingProgress || this.progressActive) return;
      this.progressActive = true;
      this.shippingCopy = JSON.parse(this.querySelector('[data-delivery-copy]').textContent);
      this.shippingThreshold = Number(this.shippingProgress.dataset.threshold);
      this.cartTotal = Math.max(0, Number(this.shippingProgress.dataset.cartTotal) || 0);
      this.cartCurrency = this.dataset.currency;
      this.progressMoney = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:'TTD',minimumFractionDigits:0,maximumFractionDigits:2});
      this.onCartRefresh = () => this.refreshDeliveryCart();
      this.onCartVisibility = () => {
        if (document.visibilityState === 'visible') this.refreshDeliveryCart();
      };
      window.addEventListener('pageshow', this.onCartRefresh);
      window.addEventListener('focus', this.onCartRefresh);
      document.addEventListener('visibilitychange', this.onCartVisibility);
      document.addEventListener('cart:updated', this.onCartRefresh);
      this.refreshDeliveryCart();
    }
    measureDock() {
      if (!this.dock || !this.isConnected) return;
      const height = Math.ceil(this.dock.getBoundingClientRect().height);
      if (height === this.dockHeight) return;
      this.dockHeight = height;
      this.style.setProperty('--bd-dock-height', height + 'px');
      document.documentElement.style.setProperty('--alchemist-preorder-dock-height', height + 'px');
    }
    updateDeliveryProgress(total, count, valid) {
      if (!this.shippingProgress || !this.progressActive) return;
      const active = valid && this.cartCurrency === 'TTD' && this.shippingThreshold > 0;
      this.shippingProgress.hidden = !active;
      this.querySelector('[data-shipping-fallback]').hidden = active;
      if (!active) return;
      const selected = this.selectionAdded ? 0 : total;
      const order = this.cartTotal + selected;
      const remaining = Math.max(0, this.shippingThreshold - order);
      const qualified = remaining === 0;
      const format = value => this.progressMoney.format(value / 100);
      const copy = (key, amount, quantity) => this.shippingCopy[key].replaceAll('__AMOUNT__', amount || '').replaceAll('__COUNT__', String(quantity || 0));
      const setText = (selector, value) => {
        const element = this.querySelector(selector);
        if (element.textContent !== value) element.textContent = value;
      };
      const prices = this.selection().filter(item => item.max > 0 && item.price > 0).map(item => item.price);
      const minimum = prices.length ? Math.min(...prices) : 0;
      let message;
      let note;
      if (qualified) {
        message = copy('unlocked');
        note = this.cartTotal > 0 ? copy(selected > 0 ? 'cart_qualified' : 'cart_only') : copy('qualified');
      } else if (count === 0 && this.cartTotal === 0) {
        message = copy('start', format(this.shippingThreshold));
        note = copy('start_note');
      } else {
        message = copy(remaining <= 10000 ? 'close' : 'away', format(remaining));
        note = this.cartTotal > 0 ? copy('with_cart', format(this.cartTotal)) : minimum > 0 && remaining <= minimum ? copy('add_one') : copy('add_many', '', minimum > 0 ? Math.ceil(remaining / minimum) : 1);
      }
      this.shippingProgress.classList.toggle('is-unlocked', qualified);
      const compactAmount = value => '$' + this.compactNumber.format(value / 100);
      const compactMessage = qualified ? this.compactCopy.delivery_unlocked : (count === 0 && this.cartTotal === 0 ? this.compactCopy.delivery_start.replaceAll('__AMOUNT__', compactAmount(this.shippingThreshold)) : this.compactCopy.delivery_away.replaceAll('__AMOUNT__', compactAmount(remaining)));
      setText('[data-compact-delivery-message]', compactMessage);
      const cartNote = this.querySelector('[data-compact-cart-note]');
      cartNote.hidden = this.cartTotal === 0;
      setText('[data-compact-cart-note]', this.cartTotal > 0 ? copy('with_cart', format(this.cartTotal)) : '');
      setText('[data-delivery-message]', message);
      setText('[data-delivery-note]', note);
      setText('[data-delivery-amount]', copy(this.cartTotal > 0 ? 'order' : 'selected', format(order)));
      setText('[data-delivery-goal]', copy('goal', format(this.shippingThreshold)));
      const percentage = Math.max(0, Math.min(100, order / this.shippingThreshold * 100));
      this.querySelector('[data-delivery-fill]').style.width = percentage + '%';
      const meter = this.querySelector('[data-delivery-meter]');
      meter.setAttribute('aria-valuenow', String(Math.round(percentage)));
      meter.setAttribute('aria-valuetext', this.compactMedia.matches ? compactMessage : message);
    }
    refreshDeliveryCart() {
      if (!this.shippingProgress || !this.progressActive) return Promise.resolve(null);
      if (this.cartRequest) return this.cartRequest;
      this.lastCartRefresh = Date.now();
      const root = this.dataset.root.replace(/\/?$/, '/');
      const controller = new AbortController();
      this.cartController = controller;
      const timeout = window.setTimeout(() => controller.abort(), 5000);
      this.cartRequest = fetch(root + 'cart.js', {headers:{'Accept':'application/json'},cache:'no-store',signal:controller.signal})
        .then(response => response.ok ? response.json() : null)
        .then(cart => {
          if (!cart || !this.isConnected || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) return null;
          this.cartTotal = cart.total_price;
          this.cartCurrency = cart.currency;
          this.update();
          return cart;
        })
        .catch(() => null)
        .finally(() => {
          window.clearTimeout(timeout);
          if (this.cartController === controller) {
            this.cartController = null;
            this.cartRequest = null;
          }
        });
      return this.cartRequest;
    }
    keepControlVisible(control) {
      if (!control || !this.dock || !this.classList.contains('bd-has-selection')) return;
      requestAnimationFrame(() => {
        if (!control.isConnected || !this.isConnected) return;
        const bottom = control.getBoundingClientRect().bottom;
        const top = this.dock.getBoundingClientRect().top;
        if (bottom > top - 16) window.scrollBy({top:bottom - top + 24,behavior:'auto'});
      });
    }
    selection() {
      return this.inputs.filter(input => !input.disabled).map(input => ({id: input.dataset.id, quantity:Number(input.value), price:Number(input.dataset.price), max:input.max === '' ? Infinity : Number(input.max)}));
    }
    update() {
      const entries = this.selection();
      const valid = this.inputs.filter(input => !input.disabled).every(input => input.value.trim() !== '') && entries.every(item => Number.isSafeInteger(item.quantity) && item.quantity >= 0 && item.quantity <= item.max);
      const count = valid ? entries.reduce((sum,item) => sum + item.quantity,0) : 0;
      const total = valid ? entries.reduce((sum,item) => sum + item.quantity * item.price,0) : 0;
      this.querySelector('[data-count]').textContent = count;
      this.querySelector('[data-total]').textContent = this.money.format(total / 100);
      this.querySelector('[data-rewards-output]').textContent = count > 0 ? (count === 1 ? this.dataset.rewardSingle : this.dataset.rewards).replaceAll('__COUNT__', String(count)) : this.initialRewards;
      this.classList.toggle('bd-has-selection',count > 0 || !valid);
      this.submit.disabled = this.busy || !valid || count < 1;
      this.inputs.forEach(input => {
        const buttons = input.closest('.bd-stepper').querySelectorAll('button');
        buttons[0].disabled = this.busy || input.disabled || !(Number(input.value) > 0);
        buttons[1].disabled = this.busy || input.disabled || (input.max !== '' && Number(input.value) >= Number(input.max));
        input.readOnly = Boolean(this.busy);
        input.closest('.bd-card').classList.toggle('is-selected',Number.isSafeInteger(Number(input.value)) && Number(input.value) > 0 && (input.max === '' || Number(input.value) <= Number(input.max)));
      });
      if (!this.busy) this.status.textContent = !valid ? this.dataset.invalid : count < 1 ? this.dataset.empty : '';
      this.updateCompactDock(count, valid);
      this.updateDeliveryProgress(total, count, valid);
      return valid && count >= 1;
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || !this.update()) return;
      const items = this.selection().filter(item => item.quantity > 0).map(({id,quantity}) => ({id,quantity,properties:{'Preorder':this.label.trim()}}));
      this.busy = true;
      this.update();
      this.submit.textContent = this.dataset.adding;
      this.status.textContent = this.dataset.adding;
      const root = this.dataset.root.replace(/\/?$/, '/');
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        if (this.cartController) this.cartController.abort();
        if (this.cartRequest) await this.cartRequest;
        this.selectionAdded = true;
        await this.refreshDeliveryCart();
        window.location.assign(root + 'cart');
      } catch (error) {
        this.busy = false;
        this.submit.textContent = this.label;
        this.update();
        this.status.textContent = error.message || this.dataset.error;
        this.classList.add('bd-submit-error');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
